import { Component, input, signal } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { VideoPopupComponent } from './video-popup/video-popup.component';
import { Guidance } from '@models';

@Component({
  selector: 'bo-video-guidance',
  templateUrl: './video-guidance.component.html',
  standalone: true,
  imports: [AngularSvgIconModule, VideoPopupComponent],
})
export class VideoGuidanceComponent {
  guidance = input.required<Guidance>();

  showPopup = signal(false);
}
